import React from "react"
import Footer from "./Footer"
import Header from "./Header"

export default function Layout({ children }) {
  return (
    <div className="relative">
      <Header />
      <div className="bg-pattern">
        {" "}
        <main className="main-layout ">{children}</main>
      </div>
      <Footer />
    </div>
  )
}
